import { SlhIcon } from "@slhuiicon/icon";
import { TemplateResult, html } from "lit";
import * as Constants from "./form-icons.constants";

export default class SlhFormIcons {
  static getHintIcon(): HTMLElement {
    const hintIcon = new SlhIcon();
    hintIcon.setAttribute("type", Constants.HINT_ICON_TYPE);
    hintIcon.setAttribute("width", String(Constants.ICON_SIZE_SMALL));
    hintIcon.setAttribute("height", String(Constants.ICON_SIZE_SMALL));
    hintIcon.setAttribute("info", "true");
    hintIcon.classList.add("hint-icon");
    return hintIcon;
  }

  static renderErrorIcon(): TemplateResult {
    return html`<slh-icon
      error
      width="${Constants.ICON_SIZE_SMALL}"
      height="${Constants.ICON_SIZE_SMALL}"
      type="${Constants.ERROR_ICON_TYPE}"
    ></slh-icon>`;
  }
}
